import { NotificationLevel } from './notifications-api-client';

/** level별 아이콘 — 색상은 컴포넌트 스타일의 CSS 클래스가 담당한다(이 함수는 아이콘 이름만). */
export function notificationLevelIcon(level: NotificationLevel): string {
  switch (level) {
    case NotificationLevel.Success:
      return 'check_circle';
    case NotificationLevel.Warning:
      return 'warning';
    case NotificationLevel.Error:
      return 'error';
    default:
      return 'info';
  }
}
